import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import Loader from '@/common/Loader';
import App from './App';
import store from './redux/store';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import { initConsentAndMaybeLoadTrackers } from './utils/consent';

if (import.meta.env.PROD) {
  const originalError = console.error;
  const originalWarn = console.warn;

  const noise = [
    'px.ads.linkedin.com',
    'aplo-evnt.com',
    'js.hs-scripts.com',
    'js.hubspot.com',
    'snap.licdn.com',
    'ERR_BLOCKED_BY_CLIENT',
    'Failed to load resource',
  ];

  console.error = (...args: any[]) => {
    const s = String(args[0] ?? '');
    if (noise.some((n) => s.includes(n))) return;
    originalError.apply(console, args);
  };

  console.warn = (...args: any[]) => {
    const s = String(args[0] ?? '');
    if (noise.some((n) => s.includes(n))) return;
    originalWarn.apply(console, args);
  };

  window.addEventListener(
    'error',
    (e) => {
      const m = e.message || '';
      if (noise.some((n) => m.includes(n))) {
        e.preventDefault();
        return false;
      }
    },
    true,
  );
}

// initConsentAndMaybeLoadTrackers();

createRoot(document.getElementById('root')!).render(
  <Suspense fallback={<Loader />}>
    <Provider store={store}>
      <BrowserRouter basename={import.meta.env.VITE_BASENAME}>
        <App />
      </BrowserRouter>
    </Provider>
  </Suspense>,
);
